export default import.meta.ROLLDOWN_FILE_URL_WFfC0775GI2z1wig8lWzrg